import TextField from "@mui/material/TextField";
import AddItemDialog from "../../Dialogs/AddItemDialog";
import { useEffect, useState } from "react";
import { ExamOverviewRow } from "../../../interfaces/examInterfaces";
import { createErrorText } from "../Functions";

const RenameFolderDialog = ({
  open,
  handleCancel,
  renameFolder,
  paths,
  pathString,
  currentName,
}: {
  open: boolean;
  handleCancel: () => void;
  renameFolder: (name: string) => void;
  paths: Record<string, ExamOverviewRow[]> | null;
  pathString: string;
  currentName: string | undefined;
}) => {
  const [name, setName] = useState("");
  const [errorText, setErrorText] = useState<string | null>(null);

  const resetFields = () => {
    if (!open) {
      setName("");
    } else if (currentName) {
      setName(currentName);
    }
  };

  useEffect(() => {
    resetFields();
  }, [open]);

  useEffect(() => {
    setErrorText(createErrorText(paths, pathString, name));
  }, [name]);

  return (
    <AddItemDialog
      open={open}
      handleCancel={() => handleCancel()}
      handleConfirm={() => renameFolder(name)}
      title={"Ordner umbenennen"}
      description={"Wähle einen neuen Namen"}
      confirmText={"OK"}
      confirmAllowed={errorText === null}
    >
      <TextField
        margin="dense"
        id="name"
        label="Name"
        required
        error={errorText !== null}
        style={{ width: 330 }}
        autoFocus
        value={name}
        onChange={(e) => {
          setName(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.code === "Enter" && errorText === null) {
            renameFolder(name);
          }
        }}
        helperText={errorText ?? errorText}
      />
    </AddItemDialog>
  );
};

export default RenameFolderDialog;
